<template>
  <div
    class="rounded px-2 py-4 space-y-3"
    style="
      width: 100%;
      height: 248px;
      background: linear-gradient(315deg, #ff5585 0%, #268cff 100%);
      border-radius: 8px;
    "
  >
    <div class="flex items-center px-2" v-for="(item, i) in ranks" :key="i">
      <SortTag
        :sortValue="i + 1"
        style="width: 16px; height: 16px; font-size: 12px"
      ></SortTag>

      <div class="ml-2 flex justify-between flex-1 min-w-0 text-xs">
        <div>{{ item[0] }}</div>
        <div>{{ item[1] }}</div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { queryOvDaoInterData } from '@/api/dao';
import { useReqByBool } from '@/hooks';
import { computed, inject, reactive, onMounted } from 'vue';
import SortTag from '@/components/SortTag.vue';
const props = defineProps({ list: Array });
const daoPageInfo = inject('daoPageInfo');

const state = reactive({
  list: [],
});
const ranks = computed(() => {
  const platMap = {};
  state.list.forEach((x) =>
    x.info.forEach((y) => {
      if (!platMap[y.plat]) {
        platMap[y.plat] = 0;
      }
      platMap[y.plat] += y.count;
    }),
  );
  const res = Object.entries(platMap);
  res.sort((a, b) => a - b);

  return res;
});

const { loadData, loading } = useReqByBool(async () => {
  try {
    const res = await queryOvDaoInterData(daoPageInfo.vueState.info.id);
    state.list = res;
  } catch (error) {
    console.log(error);
  }
});

onMounted(() => {
  loadData();
});
</script>
<style></style>
